/* unplugin-vue-components disabled */import script from "./multi-column.vue?vue&type=script&setup=true&lang=ts"
export * from "./multi-column.vue?vue&type=script&setup=true&lang=ts"

import "./multi-column.vue?vue&type=style&index=0&id=14c6ddec&lang=scss"

const __exports__ = script;

export default __exports__